import { ACCESS_LEVELS, FEATURE_FLAGS } from '@/lib/consts.js'
import { __t } from '@/lib/helpers.js'
import { useEppo } from '@/composables/eppo/index.js'
import {
  ONLINE_BOOKING_ENTRY_SOURCES,
  ONLINE_BOOKING_ENTRY_SOURCE_QUERY_KEY,
} from '@/components/settings/online-booking/consts.js'

import Details from './details.js'
import Services from './services.js'
import AdvancedOptions from './advanced-options.js'
import Subscription from './subscription.js'
import Personal from './personal.js'
import PartnerApps from './partner-apps.js'
import Payments from './payments.js'
import BooksyApp from './booksy-app.js'
import LoyaltyProgram from './loyalty-program.js'
import { ROUTE_META_PARAMS } from '@/router/consts.js'

export const SETTINGS_INVENTORY = 'settings-inventory'

const shouldOnlineBookingBeVisible = (store) => {
  const { identity, business } = store.state

  if ([ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.OWNER].includes(identity.user.access_level)) {
    return true
  }

  if (business.business.is_visible_in_marketplace) {
    return true
  }

  return false
}

const shouldInventoryBeVisible = (store) => {
  const { identity } = store.state
  const isMicroFrontendInventoryEnabled = () => !!useEppo()?.ff(FEATURE_FLAGS.Feature_MicroFrontendInventory)

  return [ACCESS_LEVELS.RECEPTION, ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.OWNER].includes(identity.user.access_level) && isMicroFrontendInventoryEnabled()
}

export default {
  path: 'settings',
  name: 'settings',
  meta: {
    title: __t('routes.settings.title'),
    backgroundIcon: 'settings',
    useSmartlook: true,
  },
  component: () => import('@/views/business/settings/index.vue'),
  children: [
    Payments,
    Details,
    Services,
    AdvancedOptions,
    ...Subscription,
    Personal,
    PartnerApps,
    {
      path: 'online-booking',
      name: 'settings-online-booking',
      query: {
        [ONLINE_BOOKING_ENTRY_SOURCE_QUERY_KEY]: ONLINE_BOOKING_ENTRY_SOURCES.SETTINGS,
      },
      meta: {
        title: __t('routes.settings.online-booking.title'),
        subtitle: __t('routes.settings.online-booking.subtitle'),
        icon: 'online-booking',
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldOnlineBookingBeVisible,
        hintKey: 'hintFeatureOnlineBooking',
      },
      component: () => import('@/views/business/settings/online-booking/index.vue'),
    },
    {
      path: 'inventory',
      name: SETTINGS_INVENTORY,
      meta: {
        title: __t('routes.settings.inventory.title'),
        subtitle: __t('routes.settings.inventory.subtitle'),
        icon: 'inventory',
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldInventoryBeVisible,
      },
      component: () => import('@/views/business/settings/inventory/iframe-service.vue'),
    },
    {
      path: 'subscription-status/:type',
      name: 'settings-subscription-status',
      meta: {},
      component: () => import('@/views/business/settings/subscription/subscription-status.vue'),
    },
    {
      path: 'splash-screens/:splashScreen?',
      name: 'settings-splash-screens',
      meta: {
        fullWidth: true,
        [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: () => false,
      },
      component: () => import('@/views/business/settings/splash-screens/index.vue'),
    },
    BooksyApp,
    LoyaltyProgram,
  ],
}
